import { IJsonQuery } from '@cian/api-models/common/json_query';
import * as React from 'react';

import { FILTERS } from '../../constants/filters';
import { dealTypeFromJsonQuery, FDealType, FOfferType, offerTypeFromJsonQuery } from '../../utils/category';
import { FiltersSearchButtonsContainer } from '../../containers/FiltersSearchButtonsContainer';
import { getFiltersList } from './helpers';
import * as styles from './Filters.css';
import { FilterRegionContainer } from '../../containers/FilterRegionContainer';
import { FiltersMortgageButtonsContainer } from '../../containers/FiltersMortgageButtonsContainer';
import { FilterMortgageBuildingTypeContainer } from '../../containers/FilterMortgageBuildingTypeContainer';
import { FilterMortgageTermContainer } from '../../containers/FilterMortgageTermContainer';
import { FilterMortgageRealtyPriceContainer } from '../../containers/FilterMortgageRealtyPriceContainer';
import { FilterMortgageDownPaymentContainer } from '../../containers/FilterMortgageDownPaymentContainer';
import { ESpecialTabs } from '../../constants/specialTabs';
import { SearchRealtorsFiltersContainer } from '../../containers/SearchRealtorsFiltersContainer';
import { SearchRealtorsButtonsContainer } from '../../containers/SearchRealtorsButtonsContainer';

export interface IFiltersProps {
  jsonQuery: IJsonQuery;
  specialTabActive: ESpecialTabs | null;
}

const getFilterItems = (dealType: FDealType, offerType: FOfferType, specialTabActive: ESpecialTabs | null) => {
  if (specialTabActive === ESpecialTabs.SearchRealtors) {
    return <SearchRealtorsFiltersContainer />;
  }

  if (specialTabActive === ESpecialTabs.Mortgage) {
    return (
      <>
        <FilterMortgageBuildingTypeContainer className={styles['mortgage_building_type']} />
        <FilterMortgageRealtyPriceContainer className={styles['mortgage_realty_price']} />
        <FilterMortgageDownPaymentContainer className={styles['mortgage_down_payment']} />
        <FilterMortgageTermContainer className={styles['mortgage_term']} />
        <FilterRegionContainer className={styles['mortgage_region']} />
      </>
    );
  }

  const filters = getFiltersList(dealType, offerType);

  return filters.map(filterName => {
    const filter = FILTERS[filterName];
    const { component: Component } = filter;

    return <Component key={`filter_${filterName}`} dealType={dealType} offerType={offerType} />;
  });
};

const getFilterButtons = (specialTabActive: ESpecialTabs | null, offerType: FOfferType) => {
  if (specialTabActive === ESpecialTabs.SearchRealtors) {
    return <SearchRealtorsButtonsContainer />;
  }

  if (specialTabActive === ESpecialTabs.Mortgage) {
    return <FiltersMortgageButtonsContainer />;
  }

  return <FiltersSearchButtonsContainer showFindOnMapButton={offerType !== FOfferType.Coworking} />;
};

export function Filters(props: IFiltersProps) {
  const { jsonQuery, specialTabActive } = props;
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const filterItem = getFilterItems(dealType, offerType, specialTabActive);
  const filterButtons = getFilterButtons(specialTabActive, offerType);

  return (
    <>
      <div className={styles['container']} data-mark="Filters">
        <div className={styles['wrapper']}>{filterItem}</div>
      </div>
      <div className={styles['buttons']}>{filterButtons}</div>
    </>
  );
}
